app.mediator.registerModule(MODULE_NAME__AUXNAV, function(app) {
	return {

        $rootElem: null,

		//==========================================================xdiv2====
		// Start and stop
		//===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

		init: function() {

			// Init
			var scope = this;
            this.$rootElem = $('.aux-nav');
            if (!this.$rootElem.length) return;
            scope.addDomListeners();
            scope.addMediatorListeners();
		},

        addDomListeners: function () {
			this.$rootElem.find('.geo-trigger').click(function(e) {
                app.mediator.notify(EVENT_NAME__AUXNAV__LANGUAGE_SELECT_BUTTON_CLICKED, {
                    target: e.target
                });
			});
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__GEO_SELECT__CLOSED, function (data) {
                if ($(data.lastOpenedByElem).closest('.aux-nav').length) {
                    scope.focusFirstItem();
                }
            });
        },
		
		//==========================================================xdiv2====
		// Module
		//===================================================================

        focusFirstItem: function () {
            this.$rootElem.find('button').focus();
        }

	};
});
